/**
 * Стандартизированные коды ошибок, передаваемые с бэкенда.
 * Значения должны совпадать с теми, что использует ваш бэкенд.
 */
export const WS_ERROR_TYPES = {
    // Общие ошибки
    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED', // Пользователь не авторизован
    FORBIDDEN: 'FORBIDDEN',       // У пользователя нет прав (но не из-за тарифа)
    BLACKLISTED: 'BLACKLISTED',   // Сервер находится в черном списке

    // Ошибки модулей
    CONNECTION_FAILED: 'CONNECTION_FAILED', // Общая ошибка подключения к серверу
    TARGET_OFFLINE: 'TARGET_OFFLINE',       // Целевой сервер оффлайн
    OPERATION_FAILED: 'OPERATION_FAILED',     // Общая ошибка выполнения операции
    PROCESS_TIMEOUT: 'PROCESS_TIMEOUT',     // Таймаут выполнения

    // Ошибки, связанные с тарифами/доступом
    INSUFFICIENT_PLAN: 'INSUFFICIENT_PLAN',   // <--- Главный код ошибки для тарифа
    RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',

    // Специфичные ошибки RCON
    RCON_AUTH_FAILED: 'RCON_AUTH_FAILED',
    RCON_COMMAND_ERROR: 'RCON_COMMAND_ERROR',

    // ... добавьте другие коды по мере необходимости ...
};